import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initPostHog } from './posthog';
import { initSentry, SentryErrorBoundary } from './sentry';

initPostHog();
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SentryErrorBoundary fallback={
    <div style={{ padding: 40, textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h2>Algo salió mal</h2>
      <p>Ya nos enteramos del error. Intenta recargar la página.</p>
      <button onClick={() => window.location.reload()} style={{ marginTop: 16, padding: '10px 20px', cursor: 'pointer' }}>
        Recargar
      </button>
    </div>
  }>
    <App />
  </SentryErrorBoundary>
);

reportWebVitals();

// ── Service Worker (PWA) ──────────────────────────────────────────
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => console.log('[Choyero SW] Registrado:', reg.scope))
      .catch((err) => console.warn('[Choyero SW] Error al registrar:', err));
  });
}
